// extracted by mini-css-extract-plugin
export default {"CheckboxWrapper":"Checkbox_CheckboxWrapper__s6VYB","CheckboxInput":"Checkbox_CheckboxInput__4extL","CheckboxDelegate":"Checkbox_CheckboxDelegate__Mhyur"};